import { useEffect, useRef } from "react";
import { useImmer } from "use-immer";

interface WorkflowState {
  showRating: boolean;
  restartFromFirstNode: boolean;
}

interface UiState {
  overlayWidth: number;
  pendingMessage: string | null;
}

export const useUiActionsChatState = () => {
  const panelRef = useRef<HTMLDivElement | null>(null);

  const [workflowState, setWorkflowState] = useImmer<WorkflowState>({
    showRating: false,
    restartFromFirstNode: true,
  });

  const [uiState, setUiState] = useImmer<UiState>({
    overlayWidth: 476,
    pendingMessage: null,
  });

  useEffect(() => {
    if (panelRef.current?.clientWidth) {
      setUiState((draft) => {
        draft.overlayWidth = panelRef.current!.clientWidth + 41;
      });
    }
  }, [setUiState]);

  const setShowRating = (value: boolean) => {
    setWorkflowState((draft) => {
      draft.showRating = value;
    });
  };

  const setRestartFromFirstNode = (value: boolean) => {
    setWorkflowState((draft) => {
      draft.restartFromFirstNode = value;
    });
  };

  return {
    panelRef,
    workflowState,
    uiState,
    setShowRating,
    setRestartFromFirstNode,
  };
};
